import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { label: "Services", href: "#services" },
  { label: "Pricing", href: "#pricing" },
  { label: "Process", href: "#process" },
  { label: "Work", href: "#work" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-4 pt-4" data-testid="navbar">
      <nav
        className={`mx-auto flex max-w-6xl items-center justify-between rounded-full px-5 py-3 transition-all duration-300 ${
          scrolled
            ? "bg-white/80 backdrop-blur-xl border border-[#DCECE3] shadow-[0_8px_30px_rgba(11,40,27,0.06)]"
            : "bg-white/40 backdrop-blur-md border border-white/40"
        }`}
      >
        <a href="#top" data-testid="nav-home-link">
          <Logo />
        </a>

        <div className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-[#4A6657] hover:text-[#0B281B] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-cta-button"
            className="inline-flex items-center rounded-full bg-[#0B281B] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#1A3F2C]"
          >
            Contact us
          </a>
        </div>

        <button
          className="md:hidden text-[#0B281B]"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div
          className="md:hidden mx-auto mt-2 max-w-6xl rounded-3xl bg-white border border-[#DCECE3] p-5 shadow-lg"
          data-testid="nav-mobile-menu"
        >
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-[#0B281B]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center rounded-full bg-[#0B281B] px-5 py-3 text-sm font-medium text-white"
            >
              Contact us
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
